import FetchService from "../FetchService/CustomService";
import { getErrorMessage } from "../utils";
import { STORAGE_ITEMS } from "../constants";
import CookieService from "services/CookieService";

const BaseUrl = process.env.BASE_URL;

const ProfileService = {
  async editProfile({ data, options = {}, callback = null, isLoader = true }) {
    const loaderConfig = { hasLoader: isLoader };
    let url = BaseUrl + "/recruiter/edit-profile";
    let recievedHeaders = options.headers;
    let headers = { ...recievedHeaders };
    try {
      const res = await FetchService.postCall({
        url,
        body: {
          ...data
        },
        headers,
        options,
        loaderConfig
      });
      if (callback) callback();

      return res;
    } catch (error) {
      console.log("service error", error);
      return Promise.reject(getErrorMessage(error));
    }
  },

  async upload({
    file,
    type = "PROFILE_IMAGE",
    options = {},
    callback,
    isLoader = true
  }) {
    const loaderConfig = { hasLoader: isLoader };
    let url = BaseUrl + "/recruiter/upload";
    let recievedHeaders = options.headers;
    // DO NOT set Content-Type for FormData - let browser set it with boundary
    let headers = {
      ...recievedHeaders
    };

    // Create FormData
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);

    try {
      const res = await FetchService.postCall({
        url,
        body: formData,
        headers,
        options,
        loaderConfig
      });
      if (callback) callback();

      return res;
    } catch (error) {
      console.log("upload error", error);
      return Promise.reject(getErrorMessage(error));
    }
  },

  async addDocument(fileData, isLoader = true) {
    try {
      const url = BaseUrl + "/recruiter/add-document";
      const loaderConfig = { hasLoader: isLoader };

      // Handle whatsapp tracking ID if present
      const waRecTrackingId =
        typeof window !== "undefined"
          ? localStorage.getItem(STORAGE_ITEMS.waRecTrackingId)
          : null;

      let requestData = fileData;

      if (waRecTrackingId) {
        if (fileData instanceof FormData) {
          fileData.append("is_sent_using_w_link", true);
          requestData = fileData;
        } else {
          requestData = {
            ...fileData,
            is_sent_using_w_link: true
          };
        }
      }

      const res = await FetchService.postCall({
        url,
        body: requestData,
        loaderConfig,
        headers: {
          hideInterceptorMessage: "true"
        }
      });

      return res;
    } catch (error) {
      console.log("document upload error", error);
      return Promise.reject(getErrorMessage(error));
    }
  },

  async sendVerificationEmailV2(params = {}) {
    try {
      let url = BaseUrl + "/recruiter/v2/send_verification_email";
      const { hideInterceptorMessage } = params;
      const res = await FetchService.getCall({
        url,
        query: { hideInterceptorMessage: !!hideInterceptorMessage }
      });
      return res;
    } catch (error) {
      console.log("send verification error", error);
      return Promise.reject(getErrorMessage(error));
    }
  },

  async verifyOtp({ otp, options = {} }) {
    try {
      let url = BaseUrl + "/recruiter/verify-email";
      let recievedHeaders = options.headers;
      let headers = { ...recievedHeaders };
      const res = await FetchService.postCall({
        url,
        body: {
          otp
        },
        headers,
        options
      });
    } catch (error) {
      console.log("error in verifying otp", error);
      return Promise.reject(error);
    }
  },

  async verifyGoogleLogin({ data, options = {} }) {
    try {
      let url = BaseUrl + "/recruiter/update-verified-email";
      let recievedHeaders = options.headers;
      let headers = { ...recievedHeaders };
      const res = await FetchService.postCall({
        url,
        body: data,
        headers,
        options
      });
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async logoutAll({ data, options = {} }) {
    console.log("logging out from all devices");
    try {
      let url = BaseUrl + "/auth/recruiter-logout-all-device";
      let recievedHeaders = options.headers;
      let headers = { ...recievedHeaders };
      const res = await FetchService.postCall({
        url,
        headers,
        options
      });
    } catch (error) {
      console.log("error in logout", error);
      return Promise.reject(error);
    }
  },

  async logout() {
    try {
      const url = BaseUrl + "/auth/recruiter-logout";
      const res = await FetchService.postCall({
        url
      });
      return res;
    } catch (error) {
      console.log("Error while logging out", error);
      return Promise.reject(error);
    }
  },

  async getPremiumIntentBanner(data = {}) {
    try {
      const url = BaseUrl + "/recruiter/premium-intent-banner-data";
      const loaderConfig = { hasLoader: false };
      const res = await FetchService.postCall({
        url,
        body: data,
        loaderConfig
      });
      return res;
    } catch (error) {
      console.log("error in premium intent banner", error);
      return Promise.reject(getErrorMessage(error));
    }
  },

  async getOnboardingStatus() {
    try {
      const url = BaseUrl + "/recruiter/onboarding-status";
      const loaderConfig = { hasLoader: false };
      const res = await FetchService.getCall({
        url,
        loaderConfig
      });
      return res;
    } catch (error) {
      console.log("error in onboarding status", error);
      return Promise.reject(getErrorMessage(error));
    }
  },

  async getProfile() {
    try {
      const url = BaseUrl + "/recruiter/profile";
      const loaderConfig = { hasLoader: false };
      const response = await FetchService.getCall({
        url,
        loaderConfig,
        headers: {
          "device-id": CookieService.getCookie("recDeviceId") || ""
        }
      });

      // Get session ID if in browser environment
      const sessionId =
        typeof window !== "undefined"
          ? localStorage.getItem(STORAGE_ITEMS.recruiterSessionId) || ""
          : "";

      // Create the payload with session ID
      const profilePayload = {
        ...response.data,
        sessionId
      };

      return profilePayload;
    } catch (error) {
      console.log("error in fetching profile", error);
      return Promise.reject(getErrorMessage(error));
    }
  },

  async updatePhoneSendOTP({ phone, options = {}, callback, isLoader = true }) {
    const loaderConfig = { hasLoader: isLoader };
    let url = BaseUrl + "/recruiter/update_phone_send_otp";
    let recievedHeaders = options.headers;
    let headers = { ...recievedHeaders };

    try {
      const res = await FetchService.postCall({
        url,
        body: {
          phone,
          is_four_digit: true
        },
        headers,
        options,
        loaderConfig
      });
      if (callback) callback();

      return res;
    } catch (error) {
      console.log("updatePhoneSendOTP error", error);
      return Promise.reject(getErrorMessage(error));
    }
  },

  async updatePhoneVerifyOTP({
    phone,
    otp,
    options = {},
    callback,
    isLoader = true
  }) {
    const loaderConfig = { hasLoader: isLoader };
    let url = BaseUrl + "/recruiter/update_phone_verify_otp";
    let recievedHeaders = options.headers;
    let headers = { ...recievedHeaders };

    try {
      const res = await FetchService.postCall({
        url,
        body: {
          phone,
          otp
        },
        headers,
        options,
        loaderConfig
      });
      if (callback) callback();

      return res;
    } catch (error) {
      console.log("updatePhoneVerifyOTP error", error);
      return Promise.reject(getErrorMessage(error));
    }
  },

  async sendDeactivateOtp(phone) {
    try {
      const url = BaseUrl + "/recruiter/deactivate_send_otp";
      const res = await FetchService.postCall({
        url,
        body: { phone, is_four_digit: true }
      });
    } catch (error) {
      console.log("error in sending deactivate otp", error);
      return Promise.reject(getErrorMessage(error));
    }
  },

  async verifyDeactivateOtp({ phone, otp, reasonIds, otherReason, callback }) {
    try {
      const url = BaseUrl + "/recruiter/deactivate_verify_otp";
      const res = await FetchService.postCall({
        url,
        body: { phone, otp, reasonIds, otherReason }
      });
      if (callback) {
        callback("FRM_DEACTIVATE");
      }
    } catch (error) {
      console.log("error in verifying deactivate otp", error);
      return Promise.reject(getErrorMessage(error));
    }
  },

  async sendOtpToPhone({ phone, options = {}, callback, isLoader = true }) {
    const loaderConfig = { hasLoader: isLoader };
    let url = BaseUrl + "/recruiter/send_otp_to_phone";
    let recievedHeaders = options.headers;
    let headers = { ...recievedHeaders };

    try {
      const res = await FetchService.postCall({
        url,
        body: { phone, is_four_digit: true },
        headers,
        options,
        loaderConfig
      });
      if (callback) callback();

      return res;
    } catch (error) {
      console.log("sendOtpToPhone error", error);
      return Promise.reject(getErrorMessage(error));
    }
  },

  async verifyOtpPhone({
    phone,
    otp,
    options = {},
    callback,
    isLoader = true
  }) {
    const loaderConfig = { hasLoader: isLoader };
    let url = BaseUrl + "/recruiter/verify_otp_phone";
    let recievedHeaders = options.headers;
    let headers = { ...recievedHeaders };

    try {
      const res = await FetchService.postCall({
        url,
        body: { phone, otp, is_four_digit: true },
        headers,
        options,
        loaderConfig
      });
      if (callback) callback();

      return res;
    } catch (error) {
      console.log("verifyOtpPhone error", error);
      return Promise.reject(getErrorMessage(error));
    }
  }
};

export default ProfileService;

// export const deactivateSendOTP = phone => {
//   return dispatch => {
//     dispatch(deactivateSendOTPLoading());
//     makeAjaxRequest({
//       method: "POST",
//       url: fetchUrl("recruiter", "deactivate_send_otp"),
//       data: { is_four_digit: true, phone }
//     })
//       .then(response => {
//         dispatch(deactivateSendOTPSuccess(response.data.data));
//       })
//       .catch(error => {
//         let errorMessage = "";
//         errorMessage = getErrorMessage(error);
//         dispatch(showSnackBar(errorMessage));
//         dispatch(deactivateSendOTPFailure(error));
//       });
//   };
// };

// export const deactivateVerifyOTP = (
//   phone,
//   otp,
//   reasonIds,
//   otherReason,
//   callback
// ) => {
//   return dispatch => {
//     dispatch(deactivateVerifyOTPLoading());
//     makeAjaxRequest({
//       method: "POST",
//       url: fetchUrl("recruiter", "deactivate_verify_otp"),
//       data: {
//         phone,
//         otp,
//         deactivation_reason_id: reasonIds,
//         deactivation_reason_text: otherReason
//       }
//     })
//       .then(response => {
//         dispatch(deactivateVerifyOTPSuccess(response.data.data));
//         dispatch(logEvents(ACTION_DEACTIVATE));
//       })
//       .then(() => {
//         dispatch(showSuccessSnackBar("Successfully deactivated!!"));
//         callback("FRM_DEACTIVATE");
//       })
//       .catch(error => {
//         let errorMessage = "";
//         errorMessage = getErrorMessage(error);
//         dispatch(showSnackBar(errorMessage));
//         dispatch(deactivateVerifyOTPFailure(error));
//       });
//   };
// };
